// extracted by mini-css-extract-plugin
export var button = "ApplePayButton-module__button___c_TJX";
export var logo = "ApplePayButton-module__logo___PfWdq";
export var text = "ApplePayButton-module__text___H2R8g";